import { useTranslation } from 'next-i18next';

import { EmailInputI18nLabelProps } from '@proprioo/salatim';

export const useEmailSuggestionLabels = (): EmailInputI18nLabelProps => {
  const { t } = useTranslation();

  return {
    no: t('no'),
    suggestion: email => t('didYouMeanToTypeEmail', { email }),
    yes: t('yes')
  };
};
